export * from "-!../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SortableMenuItems.vue?vue&type=style&index=0&id=e6bd62ec&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/SortableMenuItems.vue?vue&type=style&index=0&id=e6bd62ec&prod&scoped=true&lang=css&
// module id = 2429
// module chunks = 5